const mainHeader = {
  portugues: {
    nav: {
      pageSubscribeLogout: 'ASSINE AGORA',
      pageSubscribeLogin: 'ASSINE AGORA',      
      minhaConta: 'MINHA CONTA',
      freeTour: 'FREE TOUR',
      login: 'LOGIN',
      models: 'MODELOS',
      lives: 'LIVES',
      videos: 'VÍDEOS'
    }
  },
  ingles: {
    nav: {
      pageSubscribeLogout: 'SUBSCRIBE',
      pageSubscribeLogin: 'SUBSCRIBE',      
      minhaConta: 'MY ACCOUNT',
      freeTour: 'FREE TOUR',
      login: 'LOGIN',      
      models: 'MODELS',
      lives: 'LIVES',
      videos: 'VIDEOS'
    }
  }
}

export default mainHeader
